import { MutationTree } from "vuex";
import { ApplicationList } from "./interfaces/application-list.interface";

import {
  CLEAR_APPLICATION_LIST,
  SET_IS_LOADED,
  SET_APPLICATIONS_LIST,
  SET_SIZE_PAGES,
  SET_FILTER_CONTROL,
  SET_ACTIVE_PAGE,
  SET_TOTAL_PAGES,
  SET_SAVE_FILTER_CONTROL,
  SET_IS_OPEN_FILTER,
  SET_ARCHIVE
} from "./constants/mutations-type";

export const mutations: MutationTree<ApplicationList> = {
  [SET_TOTAL_PAGES](state, num: number) {
    state.totalPages = num;
  },
  [SET_ACTIVE_PAGE](state, num: number) {
    state.activePage = num;
  },
  [SET_SIZE_PAGES](state, num: number) {
    state.sizePage = num;
  },
  [SET_APPLICATIONS_LIST](state, applications: []) {
    state.applicationsList = [...applications];
  },
  [SET_IS_LOADED](state, val: boolean) {
    state.isLoaded = val;
  },
  [CLEAR_APPLICATION_LIST](state) {
    state.sizePage = 10;
    state.activePage = 1;
    state.totalPages = null;
  },
  [SET_FILTER_CONTROL](
    state,
    { name, value }: { name: string; value: string | boolean }
  ) {
    state.filterControls[name] = value;
  },
  [SET_SAVE_FILTER_CONTROL](
    state,
    { name, value }: { name: string; value: string | boolean }
  ) {
    state.saveFilterControls[name] = value;
  },
  [SET_IS_OPEN_FILTER](state, val: boolean) {
    state.isOpenFilter = val;
  },
  [SET_ARCHIVE](state, val: boolean) {
    state.isArchive = val;
  }
};
